<template>
  <div class="app-container">
    <!-- 查询条件 -->
    <div ref="searchBox" class="formBox margbot">
      <el-form :inline="true" :model="formData" class="demo-form-inline" ref="formData" label-width="100px" size="mini" style="width: 100%;">
        <el-form-item label="收款时间:">
          <el-date-picker v-model="formData.collectTimeStart" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>-
          <el-date-picker v-model="formData.collectTimeEnd" size="mini" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期"></el-date-picker>
        </el-form-item>
        <el-form-item label="结算客户:">
          <el-select v-model="formData.paymentAccount" size="mini" placeholder="请选择" filterable clearable>
            <el-option v-for="(item,index) in keHuOptions" :key="index" :label="item.showName" :value="item.showName">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务单号:">
          <el-input v-model="formData.businessNo" placeholder="请输入" size="mini"></el-input>
        </el-form-item>
        <el-form-item label="收款方式:">
          <el-select v-model="formData.collectType" size="mini" placeholder="请选择" filterable clearable>
            <el-option v-for="(item,index) in SKMethods" :key="index" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <br />
        <el-form-item>
          <el-button type="primary" size="mini" @click="chaxun" v-if="btnFlg[0]" btnCode="003P01jB001">查询</el-button>
          <el-button type="primary" size="mini" @click="chongzhi" v-if="btnFlg[1]" btnCode="003P01jB002">重置</el-button>
          <el-button type="primary" size="mini" @click="daochu" v-if="btnFlg[2]" btnCode="003P01jB003">导出</el-button>
        </el-form-item>
        <el-form-item>
          <span style="margin-left:10px;">应收合计：<span style="color: red">{{ Yheji }}</span>元</span>
          <span style="margin-left:10px;">实收合计：<span style="color: red">{{ Sheji }}</span>元</span>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div :style="{ height: h }">
      <el-table height="100%" size="mini" border center bordersize="mini" ref="tabref1" :data="tableData" style="width: 100%" class="tableComent" :header-cell-style="{ background: '#F5F5F5', color: 'black' }" highlight-current-row @row-click="dianjixuanzhong">
        <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="outCustomerName" label="出库客户" align="center" width="220"></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="outCustomerName" label="货主名称" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="businessNo" label="业务单号" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="weight" label="重量（吨）" align="center" width="150"></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="outstockPlateNumber" label="出库车号" align="center" width="220"></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="outstockPlateNumber" label="车牌号" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="receivableFee" label="应收" align="center" width="150">
          <template v-slot="scope">
            <div>
              <span>{{Number(scope.row.receivableFee).toFixed(2)}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="paymentFee" label="实收" align="center" width="150">
          <template v-slot="scope">
            <div>
              <span>{{Number(scope.row.paymentFee).toFixed(2)}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="collectStateName" label="状态" align="center" width="120">
          <!-- <template v-slot/ -->
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="paymentAccount" label="结算客户" align="center" width="220"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="collectTypeName" label="收款方式" align="center" width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="collectTime" label="收款时间" align="center" width="200"></el-table-column>
        <!-- <el-table-column :show-overflow-tooltip="true" prop="paymentAccount" label="付款账户" align="center" width="200"></el-table-column> -->
        <el-table-column :show-overflow-tooltip="true" prop="collectPerson" label="收款人" align="center" width="200"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="payNo" label="交易单号" align="center" width="150"></el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: right">
      <el-pagination background @current-change="handleCurrentChange" :current-page="pageInfo.pageNo" :page-size="pageInfo.pageSize" :page-sizes="[10, 20, 30, 40, 50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
    </div>
  </div>
</template>

<script>
import { getCollectRecordList, getCollectRecordAllfee } from '@/api/wms-stock'

import { exportExcel } from '@/utils/fileDown.js'
import {
  getQueryCusterData // 客户
} from '@/api/platform-settlement'
import { getBtn } from '@/utils/getButton'

export default {
  name: 'collectionSchedule',
  data () {
    return {
      formData: {
        collectTimeStart: '',
        collectTimeEnd: '',
        paymentAccount: '',
        businessNo: '',
        collectType: ''
      },
      pageInfo: {
        pageNo: 1,
        pageSize: 20
      },
      h: '500px',
      SKMethods: [
        { id: '', name: '全部' },
        { id: '1', name: '预存款' },
        { id: '2', name: '付款码' },
        { id: '3', name: '其他' }
      ],
      keHuOptions: [],
      tableData: [],
      xuanzhongArr: null,
      total: 0,
      Yheji: 0,
      Sheji: 0,
      btnFlg: [],
      btnIdArr: ['003P01jB001', '003P01jB002', '003P01jB003']
    }
  },
  methods: {
    chaxun () {
      this.pageInfo.pageNo = 1
      this.getCollectRecordLists()
    },
    getCollectRecordLists () {
      getCollectRecordList(
        {
          ...this.pageInfo,
          ...this.formData
        }
      )
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.getCollectRecordAllfees()
        })
        .catch(error => {
          this.$message({ message: error.message, type: 'error' })
        })
    },
    getCollectRecordAllfees () {
      getCollectRecordAllfee({
        ...this.pageInfo,
        ...this.formData
      })
        .then(res => {
          this.Yheji = res.receivableFee
          this.Sheji = res.paymentFee
        })
        .catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
    },
    chongzhi () {
      this.formData.collectTimeStart = ''
      this.formData.collectTimeEnd = ''
      this.formData.paymentAccount = ''
      this.formData.businessNo = ''
      this.formData.collectType = ''
      this.chaxun()
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/storageFee/exportCollectRecordList',
        { ...this.formData },
        '收款记录'
      )
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
      // this.JfgetThreadDetailExpLists()
    },
    handleCurrentChange (val) {
      this.pageInfo.pageNo = val
      this.getCollectRecordLists()
    },
    handleSizeChange (val) {
      this.pageInfo.pageSize = val
      this.getCollectRecordLists()
    },
    // 获取所属客户数据
    getQueryCusterData () {
      getQueryCusterData().then(res => {
        this.keHuOptions = res
      }).catch(err => {
        this.$message({ message: err.message, type: 'error' })
      })
    }
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 170 + 'px'
    this.btnFlg = getBtn(this.btnIdArr, '/collectionSchedule')
    this.chaxun()
    this.getQueryCusterData()
  }
}
</script>

<style lang="less" scoped>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}
</style>
